import {
    FETCH_CLOSE_BILL_REPORT_HEADER_REQUEST,
    FETCH_CLOSE_BILL_REPORT_HEADER_SUCCESS,
    FETCH_CLOSE_BILL_REPORT_HEADER_FAILURE
} from './closebillReport.actionType';

export const CLOSE_BILL_ENTRY = 'closebillentry';

let initialState = {
    loading: false,
    closebilldata: [],
};

export let closebillEntryReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_CLOSE_BILL_REPORT_HEADER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CLOSE_BILL_REPORT_HEADER_SUCCESS:
            return{
                ...state,
                loading: false,
                closebilldata: updatePayload?.BED
            };
        case FETCH_CLOSE_BILL_REPORT_HEADER_FAILURE:
            return {
                ...state,
                loading: false
            };
   
        default:
            return state;
    }
};
